$(function(){
    $('.product__accordion.accordion summary').click(function(){
        if($(this).attr('aria-expanded') == 'true' ){
            $(this).find('.toggle_btn').addClass('on')
        }else{
            $(this).find('.toggle_btn').removeClass('on')
        }
    })
    
    if($('.product__accordion').length > 0){
        $('div.accordion__content').each(function() {
            const text = $(this).text().trim();
            const parts = text.split('.').map(s => s.trim()).filter(Boolean);
            const wrapped = parts.map(s => `<span>${s}</span>`).join('');
            $(this).html(wrapped);
        });

        $('.product__accordion').each(function() {
            const thisRel = $(this).attr('rel');
            if(thisRel.includes('If You')){
                $(this).find('div.accordion__content span').addClass('if_you');
            }else if(thisRel.includes('Best Times')){
                $(this).find('div.accordion__content span').prepend('<i class="chk"><img src="https://cdn.shopify.com/s/files/1/0715/3385/5010/files/check_circle.svg?v=1760347672"></i>')
                $(this).find('div.accordion__content span').addClass('best_times');
            }else if(thisRel.includes('How To Use')){
                $(this).find('div.accordion__content span').addClass('how_to_use');
                $('.how_to_use').each(function() {
                    $(this).prepend('<i>Step 0'+($(this).index() + 1)+'</i>')
                });
            }else if(thisRel.includes('Explained')){
                $(this).addClass('exp');
            }else if(thisRel.includes('Usage')){
                $(this).addClass('usage');
            }
        });

    }
})